export interface NewsItem {
  id: string;
  tag: string;
  title: string;
  body: string;
  content?: string[]; // Full story paragraphs
  url?: string;
  date: string;
  pinned?: boolean;
  author?: string;
  readTime?: string;
  image?: string;
}

export const SERVER_NEWS: NewsItem[] = [
  {
    id: "halloween-2026-build-contest",
    tag: "Event",
    title: "Halloween 2026 Build Contest & Haunted Grounds Opened",
    body: "Construct your best horror-themed build within your assigned plot! High-value in-game rewards, mystery loot chests, and custom server trophies await the most creative builders. Registration closes November 01.",
    content: [
      "Halloween is creeping around the corner, and we are kicking off a massive seasonal building spectacle on Uge Appage SMP!",
      "Every whitelisted citizen who registers before the deadline will be assigned a designated Build Area / Plot in the event territory. Your challenge is simple yet intense: construct your scariest, most atmospheric, and creative Halloween-themed masterpiece.",
      "Whether you envision a cursed graveyard, a rotting Victorian manor, an eldritch creature emerging from the depths, or an eerie pumpkin patch—let your dark imagination run wild! The highest scoring creations will receive exclusive legendary loot, custom in-game relics, and high-value prizes directly from server administration.",
      "Key Dates to Remember:\n• Registration Opens: October 26, 2026\n• Registration Closes: November 01, 2026 at 23:59:59\n• Building Period Begins: October 31, 2026",
      "Head over to our official registration portal on the website to secure your plot before registrations lock down permanently."
    ],
    url: "/news/halloween-2026-build-contest",
    date: "2026-10-26T19:42:00Z",
    pinned: true,
    author: "SMP High Council & Staff",
    readTime: "3 min read",
    image: "/assets/banner.webp"
  },
  {
    id: "season-3-is-live",
    tag: "Server",
    title: "Season 3: The Sovereign Civilization is Live",
    body: "Whitelist applications are open on the website. Step into the sovereign realm featuring a 1B LKR macroeconomic reserve, 16 industrial patents, and crossplay between Java and Bedrock.",
    content: [
      "We are beyond excited to welcome all survivors to Uge Appage SMP Season 3: The Sovereign Civilization! After months of architectural development, economic engineering, and infrastructure overhauls, the realm gates are wide open.",
      "Season 3 represents a complete departure from ordinary SMP servers. We have built an authentic living civilization governed by genuine player economics, land deeds, and industrial rights.",
      "Citizens can settle in the historic Old Town with its deep political roots or strike out into the burgeoning industrial frontier of New Town. Every transaction, machine patent, alliance, and rivalry is woven directly into the server's permanent history.",
      "Whitelist applications and voice interviews are processed daily through our official verification hub. Prepare your application and join the sovereign brotherhood."
    ],
    url: "/news/season-3-is-live",
    date: "2026-10-20T10:00:00Z",
    author: "WJ Biman (Jabuu.x)",
    readTime: "4 min read",
    image: "/assets/welcome.webp"
  },
  {
    id: "official-web-portal-launch",
    tag: "Portal",
    title: "The Official SMP Web Portal is Officially Live",
    body: "Brand-new reimagined web portal with live citizen dossiers, interactive YouTube broadcast sync, real-time macroeconomic vaults, and digital physical wallet inspectors.",
    content: [
      "We are proud to unveil the brand-new, completely reimagined Official Web Portal for Uge Appage SMP Season III!",
      "A living Minecraft civilization deserves a digital interface to match. The portal introduces real-time Citizen Dossiers connected to Discord and in-game data, dynamic YouTube live broadcast banners, digital ledger checks, and responsive documentation across desktop, tablet, and mobile.",
      "Explore the macroeconomic reserve, inspect currency serial tiers, read the official constitution, and submit your citizen credentials all under one unified platform."
    ],
    url: "/news/official-web-portal-launch",
    date: "2026-10-16T11:52:00Z",
    author: "Web Operations Team",
    readTime: "2 min read",
    image: "/assets/harbor-town.webp"
  },
  {
    id: "cross-play-bedrock-mobile-support",
    tag: "Update",
    title: "Full Cross-Play Support Live (Java, Bedrock & Mobile)",
    body: "Our world is now united across platforms! Join from Java PC (Port 25565) or Bedrock on Android, iOS, Windows, and consoles (Port 19132) seamlessly on the same shared map.",
    content: [
      "Cross-play support is officially active on Uge Appage SMP! Our world is no longer confined solely to Java Edition PC users.",
      "Whether you connect from an iPhone/iPad, Android phone, Nintendo Switch, PlayStation, Xbox, or Windows 10/11 Bedrock edition, you can now enter the exact same server world alongside Java players.",
      "How to Connect:\n• Java Edition: play.ugeappagesmp.online (Default Port: 25565)\n• Bedrock / Pocket Edition: play.ugeappagesmp.online (Port: 19132)",
      "Form alliances, construct sovereign fortresses, and experience high-stakes survival together without platform boundaries."
    ],
    url: "/news/cross-play-bedrock-mobile-support",
    date: "2026-09-27T06:40:00Z",
    author: "Systems Architecture",
    readTime: "3 min read",
    image: "/assets/bedrock_announcement.webp"
  },
  {
    id: "1-billion-lkr-macroeconomic-reserve",
    tag: "Economy",
    title: "1 Billion LKR Macroeconomic Reserve Activated",
    body: "The Central Reserve Vault is operational with physical currency denominations from Rs. 20 to Rs. 100,000, real estate land claiming, and player-driven commerce.",
    content: [
      "The Central Reserve Vault has officially initialized the sovereign currency framework backing Uge Appage SMP Season 3 with a 1 Billion LKR asset ceiling.",
      "Unlike conventional scoreboard money plugins, currency inside Uge Appage SMP exists as tangible, custom-textured physical banknote tokens ranging from Rs. 20, Rs. 50, Rs. 100, Rs. 500, Rs. 1,000, Rs. 2,000, Rs. 5,000, to the rare Rs. 10,000 and Rs. 100,000 Treasury Notes.",
      "Real estate land claiming algorithms dynamically price terrain according to global market velocity, ensuring real supply and demand governs all territory development.",
      "Visit our dedicated Economy page to explore currency denominations, town tax frameworks, and industrial licensing rules."
    ],
    url: "/news/1-billion-lkr-macroeconomic-reserve",
    date: "2026-09-15T12:00:00Z",
    author: "Department of the Treasury",
    readTime: "4 min read",
    image: "/assets/reserve-vault.webp"
  }
];
